import { type AppContext } from "~/lib/context";

export const applyUserAwareTFunction = (ctx: AppContext) => {
  if (ctx.user) {
    ctx.t = ctx.i18n.getFixedT(ctx.user.locale.toLowerCase());
  }
};
